import React from 'react';
const Institutes = () => <div className="service-page"><h1>Institutes</h1><p>Find top educational institutes for all streams and courses.</p></div>;
export default Institutes;
